export enum ProjectModelEditOptions {
  EditDataSchemaOptions = 'EditDataSchemaOptions',
  GenerateCrudPages = 'GenerateCrudPages',
  GenerateDataStore = 'GenerateDataStore'
}
